import * as T from './types';

export default function reducer(state = true, action = {}) {
  if (action.type === T.SET_SSR) {
    return action.payload;
  }
  return state;
}
